export const API_KEY = `705a971a-6b03-4cd1-9775-3da186a9b5a2`;
export const URL = `https://api-maps.yandex.ru/2.1/`;

export const MapParam = {
  ZOOM: 16,
  ICON: {
    URL: `/assets/templates/main/images/icons/map-point.svg`,
    SIZE: [61, 91]
  }
};

export const ANIMATION_DURATION = 200;

export const EventType = {
  INSTANT: `INSTANT`
};

export const MediaRuleType = {
  DEFAULT: `default`
};
